import React, {
    useContext,
    useEffect,
    useState,
} from "react";
import {  useForm } from "react-hook-form";

import {
    Wrapper,
    Line,
    Heading,
    UploadWrapper,
    ReuploadCopy,
    DocumentUploadCopy,
    Icon,
    ModalWrapper,
} from "../components/StepFour/style";
import {
    getUploadedDocuments,
    uploadBusinessDocumentV4,
} from "../../../../pages/Compliance/complianceAPI";
import { UploadFn } from "../../utils";
import {
    useAppSelector,
} from "../../../../app/hooks";
import Loader from "../../../common/Loader";
import { NetworkErrorAlertContext } from "../../../../context/NetworkErrorAlert";
import { useNavigate } from "react-router-dom";
import DocumentUpload from "../../../common/DocumentUpload/DocumentUpload";
import { Button } from "../../../common/Button";
import CustomModal from "../../../common/CustomModal";
import { Divider } from "../../../../pages/Onboarding/styles";
import { getMostRecentUploadedDocs } from "../../../../pages/Onboarding/utils/businessDocumentUtils";
import { useRequiredDocs } from "../../../../app/hooks/useRequiredDocs";

const Reupload = () => {
    const { onShowAlert: onShowErrorAlert } = useContext(
        NetworkErrorAlertContext,
    );
    const {
        handleSubmit,
    } = useForm();
    const [getDocList, setGetDocList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [uploadedDocuments, setUploadedDocuments] = useState([]);


    const [mockDocumentStatuses, setMockDocumentStatuses] =
        useState([]);

    const { businessId, userObj: { accountUser : { businessCountry } } } = useAppSelector(
        (state) => state.users,
    );
    const { businessTypeId, } = useAppSelector((state) => state.onboarding)
    const { requiredDocs } = useRequiredDocs({ businessTypeId, businessCountry })

    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true);
            try {
                const data =
                    await getUploadedDocuments(
                        {
                            businessId,
                        },
                    );
                setGetDocList(getMostRecentUploadedDocs(data, requiredDocs));
                setLoading(false);
            } catch (error) {
                console.error(error);
                setLoading(false);
            }
        };

        if (businessId) {
            fetchData();
        }
    }, [businessId]);

    const uploadBusinessDocument =
        (businessDocumentId: number): UploadFn =>
        (file, onUploadProgress) =>
            uploadBusinessDocumentV4({
                businessId,
                businessDocumentId,
                file,
                onUploadProgress,
            });

    const successModal = () => {
        setSuccess(true);
    };

    const handleDocumentUpload = (index: number, id?: number) => {
        setMockDocumentStatuses((prevStatuses) => {
            const newStatuses = [...prevStatuses];
            newStatuses[index] = "UPLOADED";
            return newStatuses;
        });

        setUploadedDocuments((prevUploadedDocuments) => [
            ...prevUploadedDocuments,
            id,
        ]);
    };

    const failedDocs = getDocList?.filter((doc) => doc?.documentApprovalStatus === "FAILED");
    const isUploadedDocumentsEqualFailedDocs = uploadedDocuments?.length === failedDocs?.length;
    

    const onSubmit = () => {
        successModal()
    };

    return (
        <>
            <Wrapper>
                <Loader isLoading={loading} />
                <Heading>Update your account details</Heading>
                <Line />
                <UploadWrapper>
                    {!loading && (
                        <ReuploadCopy>
                            Status of all documents
                        </ReuploadCopy>
                    )}

                    {getDocList
                        .map((doc) => (
                            <DocumentUpload
                                key={doc.id}
                                type={doc.documentApprovalStatus}
                                documentTitle={doc.businessDocument.document + (doc?.directorName ? ` (${doc?.directorName})` : '')}
                                imageId={doc.id}
                            />
                        ))}
                </UploadWrapper>

                 <Divider/>

                <UploadWrapper>
                    {!loading && (
                        <ReuploadCopy>
                            Reupload disapproved documents
                        </ReuploadCopy>
                    )}

                    {getDocList
                        ?.filter(
                            (doc) =>
                                doc.documentApprovalStatus ===
                                "FAILED"
                        )
                        ?.map((doc, index) => (
                            <div key={doc.id}>
                            <DocumentUploadCopy>
                                {doc.businessDocument.document}
                            </DocumentUploadCopy>
                            <DocumentUpload
                                key={doc.id}
                                type={
                                    mockDocumentStatuses[
                                        index
                                    ]
                                }
                                upload={uploadBusinessDocument(
                                    doc.businessDocument.id
                                )}
                                onUpload={() =>
                                    handleDocumentUpload(
                                        index,
                                        doc.businessDocument.id
                                    )
                                }
                                onShowAlert={onShowErrorAlert}
                                imageId={doc.id}
                            />
                            
                        </div>
                        ))}
                </UploadWrapper>

                {!loading && (
                    <Button
                        theme="primary"
                        label="Done"
                        onClick={handleSubmit(onSubmit)}
                        disabled={!isUploadedDocumentsEqualFailedDocs}
                    />
                )}
            </Wrapper>

            <CustomModal
                isModalVisible={success}
                onClose={() => setSuccess(false)}
                width="500px"
            >
                <ModalWrapper>
                    <Icon />
                    <h1>Document submitted successfully</h1>
                    <p>
                        Your account is being reviewed. We
                        will notify you when it is approved.
                    </p>

                    <Button
                        label="Continue"
                        theme="secondary"
                        onClick={() =>
                            navigate("/dashboard")
                        }
                    />
                </ModalWrapper>
            </CustomModal>
        </>
    );
};

export default Reupload;
